import { RequireAccess } from '@/components'
import { SettingsNav } from '@/ui'
import { StaticBrandLibrary } from '@/ui/constructs/branding/simplified'
import { useTranslation } from 'react-i18next'

export function BrandingLibrary() {
	const { t } = useTranslation('common')

	return (
		<SettingsNav active="branding-library" fullWidth fixedHeight>
			<RequireAccess
				permission="branding:read"
				fallback={
					<div className="p-4 text-sm text-gray-500">
						{t('settings.campaignSettings.noPermission')}
					</div>
				}
			>
				<StaticBrandLibrary />
			</RequireAccess>
		</SettingsNav>
	)
}
